/**
 * EB 平台管理端 API 根路径
 * 对应 view/admin/src/libs/settingMer.js：https = VUE_APP_BASE_API + '/sys'
 *
 * - 开发：VITE_APP_BASE_API=/api → /api/sys（Vite proxy 去掉 /api → 后端 /sys）
 * - 生产：可为 /api/sys 或 /api（自动补 /sys）
 */
export function getCrmebAdminApiBase(): string {
  const base = String(import.meta.env.VITE_APP_BASE_API || '/api').replace(/\/$/, '');
  return base.endsWith('/sys') ? base : `${base}/sys`;
}
